import { Component, Input } from '@angular/core';
import { Product } from 'src/app/models/interface/product/product';

type Sections = 'info' | 'orders';

@Component({
  selector: 'app-product-depth-level-product',
  templateUrl: './product-depth-level-product.component.html',
  styleUrls: ['./product-depth-level-product.component.scss']
})
export class ProductDepthLevelProductComponent {

  selected: Sections = 'info'
  domainActions: Array<string> = ['TV','FTTH'];

  private _item: Product;
  showActions: boolean

  @Input()
  get item(): Product {
    return this._item;
  }

  set item(value: Product) {
    this._item = value;
  }

  @Input() params: any;
  @Input() isps: any[];

  constructor() {
  }

  ngOnInit() {
    this.showActions = this.domainActions.includes(this.item.domainName);
  }


  changeSection(section: Sections) {
    this.selected = section;
  }


}
